import { render, staticRenderFns } from "./innovationCen.vue?vue&type=template&id=1fc5baf2&scoped=true&"
import script from "./innovationCen.vue?vue&type=script&lang=js&"
export * from "./innovationCen.vue?vue&type=script&lang=js&"
import style1 from "./innovationCen.vue?vue&type=style&index=1&id=1fc5baf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc5baf2",
  null
  
)

export default component.exports